import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  card: {
    position: 'relative',
    boxSizing: 'border-box',
    boxShadow: 'none',

    width: '100%',
    minHeight: '260px',
    padding: '32px',

    backgroundColor:
      theme.palette.mode === 'dark'
        ? theme.palette.background.contain
        : '#F4F8FC',

    borderBottomLeftRadius: '28px',
    borderBottomRightRadius: '28px',

    overflow: 'hidden',

    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: '49px',

      width: '59px',
      height: '10px',

      backgroundColor:
        theme.palette.mode === 'dark'
          ? theme.palette.background.default
          : '#FFFFFF',

      borderBottomLeftRadius: '10px',
      borderBottomRightRadius: '10px',
    },

    [theme.breakpoints.between('sm', 'md')]: {
      minHeight: '290px',
      padding: '28px',
    },

    [theme.breakpoints.between('xs', 'sm')]: {
      minHeight: '180px',
      padding: '28px',
    },

    [theme.breakpoints.down('xs')]: {
      minHeight: '160px',
      padding: '24px',

      borderBottomLeftRadius: '22px',
      borderBottomRightRadius: '22px',

      '&::before': {
        left: '36px',
        width: '48px',
        height: '8px',

        borderBottomLeftRadius: '8px',
        borderBottomRightRadius: '8px',
      },
    },
  },

  title: {
    fontFamily: 'MontserratBold',
    position: 'relative',
    zIndex: 2,

    margin: 0,
    marginBottom: '12px',

    fontSize: '22px',
    fontWeight: 700,
    textAlign: 'left',

    color: theme.palette.text.primary,

    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
      marginBottom: '10px',
    },
  },

  description: {
    fontFamily: 'MontserratRegular',
    position: 'relative',
    zIndex: 2,

    margin: 0,
    minWidth: 0,

    fontSize: '16px',
    textAlign: 'left',

    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
    },
  },
}));

export default useStyles;
